import {Module} from "../index";
import messages from "./resources/messages";
import {routes} from "./resources/routes";
import {GameCreationEventSubscriber} from "./subscribers/GameCreationEventSubscriber";
import {VueModule} from "@/modules/vue";
import {MenuNavigationComponentManager} from "@/modules/vue/services/MenuNavigationComponentManager";
import {ColorEnum} from "@/modules/vue/enums";
import {
  TransferNotification,
  TransferListing,
  TransferLog,
  TransferOffer,
  TransferOfferCareerEndNotification,
  TransferPlayerNegotiation,
  TransferTeamNegotiation, TransferOfferAbortNotification
} from "@/modules/transfer-market/entity";
import OfferCreator from "@/modules/transfer-market/services/OfferCreator";
import {NegotiationCloserInterface} from "@/modules/diplomacy/interfaces";
import {TYPES} from "@/modules/diplomacy/types";
import {TransferNegotiationCloser} from "@/modules/transfer-market/services/TransferNegotiationCloser";
import {TransferOfferHandler} from "@/modules/transfer-market/services/TransferOfferHandler";
import PlayerTransferrer from "@/modules/transfer-market/services/PlayerTransferrer";
import ListingHandler from "@/modules/transfer-market/services/ListingHandler";
import NotificationEventSubscriber from "@/modules/transfer-market/subscribers/NotificationEventSubscriber";
import AITransferEventSubscriber from "@/modules/transfer-market/subscribers/AITransferEventSubscriber";
import {NegotiationComponentManager} from "@/modules/diplomacy/services/NegotiationComponentManager";
import TransferPlayerNegotiationComponent from "./components/TransferPlayerNegotiation.vue";
import TransferTeamNegotiationComponent from "./components/TransferTeamNegotiation.vue";
import TransferLogFactory from "@/modules/transfer-market/services/factories/TransferLogFactory";
import {TransferOfferNotification} from "@/modules/transfer-market/entity/TransferOfferNotification";
import TransferOfferEventSubscriber from "@/modules/transfer-market/subscribers/TransferOfferEventSubscriber";
import TransferStatusEventSubscriber from "@/modules/transfer-market/subscribers/TransferStatusEventSubscriber";
import DirectTransferHandler from "@/modules/transfer-market/services/DirectTransferHandler";

export class TransferMarketModule extends Module {
  dependsOn = [
    VueModule,
  ];

  messages = messages;
  routes = routes;

  public entities = [
    TransferListing,
    TransferLog,
    TransferOffer,
    TransferTeamNegotiation,
    TransferPlayerNegotiation,
    TransferOfferNotification,
    TransferOfferAbortNotification,
    TransferOfferCareerEndNotification,
    TransferNotification,
  ];

  eventSubscribers = [
    GameCreationEventSubscriber,
    NotificationEventSubscriber,
    AITransferEventSubscriber,
    TransferOfferEventSubscriber,
    TransferStatusEventSubscriber,
  ];

  protected register() {
    super.register();

    this.app.bind<TransferLogFactory>(TransferLogFactory).to(TransferLogFactory);
    this.app.bind<ListingHandler>(ListingHandler).to(ListingHandler);
    this.app.bind<OfferCreator>(OfferCreator).to(OfferCreator);
    this.app.bind<TransferOfferHandler>(TransferOfferHandler).to(TransferOfferHandler);
    this.app.bind<PlayerTransferrer>(PlayerTransferrer).to(PlayerTransferrer);
    this.app.bind<DirectTransferHandler>(DirectTransferHandler).to(DirectTransferHandler);
    this.app.bind<NegotiationCloserInterface>(TYPES.NegotiationCloser).to(TransferNegotiationCloser);
  }

  boot() {
    super.boot();

    this.app.get(MenuNavigationComponentManager).addItem({
      color: ColorEnum.Zinc,
      icon: IconEnum.ArrowsHorizontal,
      route: {name: 'transfer-market.index'},
    });

    this.app.get(NegotiationComponentManager).addItem({
      class: TransferPlayerNegotiation,
      component: TransferPlayerNegotiationComponent,
    });

    this.app.get(NegotiationComponentManager).addItem({
      class: TransferTeamNegotiation,
      component: TransferTeamNegotiationComponent,
    });
  }
}
